import React from 'react';

import styles from './Message.module.css';
import cn from 'classnames';

const Message = ({ className, message }) => {
  return (
    <div className={cn(styles['wrapper'], className)}>
      <div className={styles['title']}>Интересный факт:</div>

      <div className={styles['text-wrapper']}>
        <div className={styles['text']}>{message?.content}</div>
      </div>
    </div>
  );
};

export default React.memo(Message);
